// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"42aa87e8","183":"3b7d2997","877":"2fe1667d"}[chunkId] + ".chunk.js";
};